<template>
  <main-template>
    <v-row class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Justificativa em Massa
        </h1>
      </v-col>
    </v-row>

    <v-row class="mb-3">
      <v-col cols="auto">
        <v-btn color="primary" :to="{ name: 'colaboradores.justificativaMassa.nova' }">
          <v-icon left>mdi-plus</v-icon>
          Nova Justificativa
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="justificativas"
          :loading="carregando"
          no-data-text="Nenhuma justificativa em massa registrada"
        >
          <template #[`item.data_referencia`]="{ item }">
            {{ formatarData(item.data_referencia) }}
          </template>
          <template #[`item.responsavel`]="{ item }">
            {{ item.responsavel && item.responsavel.name ? item.responsavel.name : "—" }}
          </template>
          <template #[`item.itens_count`]="{ item }">
            {{ item.itens_count }} colaborador(es)
          </template>
          <template #[`item.acoes`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="primary" v-on="on" @click="visualizar(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="warning" v-on="on" @click="editar(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="error" v-on="on" @click="confirmarExclusao(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogVisualizar" max-width="600">
      <v-card v-if="itemVisualizado">
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Detalhes da Justificativa</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="6">
              <div class="caption grey--text text--darken-1">Data de Referência</div>
              <div class="body-2 font-weight-medium">
                {{ formatarData(itemVisualizado.data_referencia) }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="caption grey--text text--darken-1">Responsável</div>
              <div class="body-2">
                {{
                  itemVisualizado.responsavel && itemVisualizado.responsavel.name
                    ? itemVisualizado.responsavel.name
                    : "—"
                }}
              </div>
            </v-col>
            <v-col cols="12">
              <div class="caption grey--text text--darken-1 mt-2">Motivo</div>
              <div class="body-2">{{ itemVisualizado.motivo }}</div>
            </v-col>
            <v-col v-if="itemVisualizado.observacao" cols="12">
              <div class="caption grey--text text--darken-1 mt-2">Observação</div>
              <div class="body-2">{{ itemVisualizado.observacao }}</div>
            </v-col>
            <v-col cols="12">
              <div class="caption grey--text text--darken-1 mt-2">
                Colaboradores ({{ colaboradoresVisualizados.length }})
              </div>
              <div class="mt-1">
                <v-chip v-for="c in colaboradoresVisualizados" :key="c.id" small class="mr-1 mt-1">
                  {{ c.name }}
                </v-chip>
                <span v-if="!colaboradoresVisualizados.length" class="grey--text body-2">—</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogVisualizar = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-text class="text-center pa-8">
          <v-progress-circular indeterminate color="primary" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExclusao" max-width="420">
      <v-card>
        <v-card-title>Confirmar Remoção</v-card-title>
        <v-card-text>
          Deseja remover a justificativa em massa de
          <strong>{{ formatarData(itemParaExcluir && itemParaExcluir.data_referencia) }}</strong
          >? Todos os colaboradores vinculados serão desvinculados desta justificativa.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="excluindo" @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn color="error" :loading="excluindo" @click="excluir">Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "JustificativaMassaPage",
  data() {
    return {
      justificativas: [],
      carregando: false,
      dialogVisualizar: false,
      itemVisualizado: null,
      dialogExclusao: false,
      excluindo: false,
      itemParaExcluir: null,
      headers: [
        { text: "Data Referência", value: "data_referencia", class: "text-no-wrap", width: "130" },
        { text: "Motivo", value: "motivo" },
        { text: "Responsável", value: "responsavel", class: "text-no-wrap" },
        { text: "Colaboradores", value: "itens_count" },
        { text: "", value: "acoes", sortable: false, align: "center", width: "120" },
      ],
    };
  },
  computed: {
    colaboradoresVisualizados() {
      if (!this.itemVisualizado) return [];
      return this.itemVisualizado.colaboradores || [];
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.justificativas =
          await this.$services.colaboradorPontosService.listarJustificativasMassa();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    editar(item) {
      this.$router.push({
        name: "colaboradores.justificativaMassa.nova",
        query: { editarId: item.id },
      });
    },
    async visualizar(item) {
      this.itemVisualizado = null;
      this.dialogVisualizar = true;
      try {
        this.itemVisualizado =
          await this.$services.colaboradorPontosService.buscarJustificativaMassa(item.id);
        console.log(this.itemVisualizado);
      } catch (error) {
        this.$handleError(error);
        this.dialogVisualizar = false;
      }
    },
    confirmarExclusao(item) {
      this.itemParaExcluir = item;
      this.dialogExclusao = true;
    },
    async excluir() {
      try {
        this.excluindo = true;
        await this.$services.colaboradorPontosService.excluirJustificativaMassa(
          this.itemParaExcluir.id
        );
        this.$toast.success("Justificativa em massa removida com sucesso!");
        this.dialogExclusao = false;
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindo = false;
      }
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>
